import * as React from 'react';
import { SelectItem, SelectType } from '../types';
import { isMultiple } from '../select-type';
import { SelectOption } from '../select-option';
import { OptionDescription, OptionBtnNextLevel } from '../option';
import { RadioSymbol, CheckSymbol } from 'ui';

export interface CategoryOptionsItemProps {
  item: SelectItem;
  showLongDescription?: boolean;
  selectType?: SelectType;
  showIcons: boolean;
  showBackgroundColour: boolean;
  onExpand: (item:SelectItem) => void;
}

export const CategoryOptionsItem = ({
  item, 
  showLongDescription,
  selectType, 
  showIcons = false,
  showBackgroundColour = false,
  onExpand
}:CategoryOptionsItemProps) => {

  const longDescriptionValue = showLongDescription && (item?.longDescription ?? '');
  const selectSymbol = isMultiple(selectType) ? <CheckSymbol /> : <RadioSymbol />;

  return <SelectOption key={item.value} selectType={selectType} hasChildren={true}
    longDescription={longDescriptionValue}>
    <OptionDescription item={item} showIcons={showIcons} selectSymbol={selectSymbol} 
      showBackgroundColour={showBackgroundColour} hideSelection={true} />
    {<OptionBtnNextLevel item={item} onClick={onExpand} />}
  </SelectOption>;
};
